import $ from "jquery";
import Cookies from "js-cookie";

const $alertEl = $(".alert");

$(function () {
  if ($alertEl.length > 0) {
    $alertEl.each(function () {
      openAlert($(this));
      saveAlert($(this));
      alertClose($(this));
    });
  }
});

const alertClose = (alertEl) => {
  alertEl.on("click", ".alert__close", function () {
    const $thisEl = $(this);
    const $targetAlert = $thisEl.closest(".alert");
    $targetAlert.removeClass('active');
    // $targetAlert.addClass("saved");
  });
};

const openAlert = (alertEl) => {
  const cookieName = alertEl.data('id');
  const $targetAlert = $(`.alert[data-id="${alertEl.data('id')}"]`);

  const cookieVal = Cookies.get(`${cookieName}`);
  console.log(cookieVal);
  console.log($targetAlert);
  if(cookieVal === undefined && $targetAlert.length) {
    // $targetAlert.removeClass('saved');
    $targetAlert.addClass('active');
  };
}
const saveAlert = (alertEl) => {
  const $cookieName = alertEl.data('id');
  const $targetAlert = $(`.alert[data-id="${alertEl.data('id')}"]`);

  $targetAlert.on('click', '.alert__close', function () {
    if(Cookies.get(`${$cookieName}`) === undefined) {
      Cookies.set(`${$cookieName}`, '1', {expires: 1});
    }
  });
}


